.root {
  &:hover {
    background-color: var(--mantine-color-gray-0);
    cursor: pointer;
  }

  &:has(.signed:hover):hover {
    background-color: var(--mantine-color-body);
    cursor: default;
  }
}
